document.addEventListener('DOMContentLoaded', () => {
    const target = document.querySelector('quick-add-dialog');
    if (!target) return;

    let dispatched = false;

    const dispatchWhenReady = () => {
        const form = target.querySelector(
            '[bss-b2b-quickview-product-form], quick-add-modal product-info'
        );

        const productId = form?.querySelector('[bss-b2b-product-id]');

        if (!form || !productId || dispatched) return;

        dispatched = true;

        document.dispatchEvent(
            new Event('bss_b2b:QuickviewLoaded', { bubbles: true })
        );
    };

    new MutationObserver(() => {
        const dialogEl = target.querySelector('dialog');
        
        if (dialogEl && dialogEl.hasAttribute('open')) {
            dispatched = false;
            setTimeout(dispatchWhenReady, 100);
        }
    }).observe(target, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['open', 'class']
    });
});

